import { useQuery } from '@tanstack/react-query'
import { getHealth } from '@stewards-fas/apis'

const QUERY_CACHE_KEY = 'health-check'

export const useServerHealthCheck = () =>
  useQuery([QUERY_CACHE_KEY, 'server'], async () => {
    return getHealth()
  })
